var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash-2",
    clipPath: "url(#clip0_444_1681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.16634 2.83333C6.98953 2.83333 6.81996 2.90357 6.69494 3.0286C6.56991 3.15362 6.49967 3.32319 6.49967 3.5V4.16667H10.4997V3.5C10.4997 3.32319 10.4294 3.15362 10.3044 3.0286C10.1794 2.90357 10.0098 2.83333 9.83301 2.83333H7.16634ZM11.833 4.16667V3.5C11.833 2.96957 11.6223 2.46086 11.2472 2.08579C10.8721 1.71071 10.3634 1.5 9.83301 1.5H7.16634C6.63591 1.5 6.1272 1.71071 5.75213 2.08579C5.37705 2.46086 5.16634 2.96957 5.16634 3.5V4.16667H2.49967C2.13148 4.16667 1.83301 4.46514 1.83301 4.83333C1.83301 5.20152 2.13148 5.5 2.49967 5.5H3.16634V14.1667C3.16634 14.6971 3.37705 15.2058 3.75213 15.5809C4.1272 15.956 4.63591 16.1667 5.16634 16.1667H11.833C12.3634 16.1667 12.8721 15.956 13.2472 15.5809C13.6223 15.2058 13.833 14.6971 13.833 14.1667V5.5H14.4997C14.8679 5.5 15.1663 5.20152 15.1663 4.83333C15.1663 4.46514 14.8679 4.16667 14.4997 4.16667H11.833ZM4.49967 5.5V14.1667C4.49967 14.3435 4.56991 14.513 4.69494 14.6381C4.81996 14.7631 4.98953 14.8333 5.16634 14.8333H11.833C12.0098 14.8333 12.1794 14.7631 12.3044 14.6381C12.4294 14.513 12.4997 14.3435 12.4997 14.1667V5.5H4.49967ZM7.16634 7.5C7.53453 7.5 7.83301 7.79848 7.83301 8.16667V12.1667C7.83301 12.5349 7.53453 12.8333 7.16634 12.8333C6.79815 12.8333 6.49967 12.5349 6.49967 12.1667V8.16667C6.49967 7.79848 6.79815 7.5 7.16634 7.5ZM9.16634 8.16667C9.16634 7.79848 9.46482 7.5 9.83301 7.5C10.2012 7.5 10.4997 7.79848 10.4997 8.16667V12.1667C10.4997 12.5349 10.2012 12.8333 9.83301 12.8333C9.46482 12.8333 9.16634 12.5349 9.16634 12.1667V8.16667Z",
    fill: "#B42318"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_444_1681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRed);
export default __webpack_public_path__ + "static/media/delete-red.3cee6e27ffd29c3e88f88e63cf94a72b.svg";
export { ForwardRef as ReactComponent };